import {
  GET_REVENUE_CENTERS_REQUESTED,
  GET_REVENUE_CENTERS_SUCCEEDED,
  GET_REVENUE_CENTERS_FAILED,
  CREATE_REVENUE_CENTERS_REQUESTED,
  CREATE_REVENUE_CENTERS_SUCCEEDED,
  CREATE_REVENUE_CENTERS_FAILED,
  UPDATE_REVENUE_CENTERS_REQUESTED,
  UPDATE_REVENUE_CENTERS_SUCCEEDED,
  UPDATE_REVENUE_CENTERS_FAILED,
  GET_AVAILABILITY_REQUESTED,
  GET_AVAILABILITY_SUCCEEDED,
  GET_AVAILABILITY_FAILED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED,
  SET_REVENUE_CENTER_OPTIMISTIC_LIST_IMAGE,
} from './constants'
import DataMapper from '../../utils/dataMapper'
import { keyBy } from 'lodash'

export const defaultState = {
  filters: {
    searchGlobalRevenueCetners: null,
    byServiceTypes: '',
  },
  serviceTypes: {},
  images: {
    list: {},
  },
}

const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case GET_REVENUE_CENTERS_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId,
        isLoading: false,
      }
    }

    case GET_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: false }

    // paginated and filtered

    case GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED: {
      const { headers, data } = payload

      const total = Number(headers?.total ?? 0)
      const byId = keyBy(data?.stands, 'uuid')

      return {
        ...state,
        pagination: {
          ...state.pagination,
          byId,
          total,
        },
        isLoading: false,
      }
    }

    case GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: false }

    // create

    case CREATE_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case CREATE_REVENUE_CENTERS_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        isLoading: false,
        pagination: {
          ...state.pagination,
          byId: { ...state.pagination.byId, ...byId },
        },
      }
    }
    case CREATE_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: true }

    // update

    case UPDATE_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case UPDATE_REVENUE_CENTERS_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        isLoading: false,
        pagination: {
          ...state.pagination,
          byId: { ...state.pagination.byId, ...byId },
        },
      }
    }

    case UPDATE_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: true }

    //Availability //
    case GET_AVAILABILITY_REQUESTED:
      return {
        ...state,
        availability: {
          ...state.availability,
          loading: true,
        },
      }

    case GET_AVAILABILITY_SUCCEEDED:
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        availability: {
          ...state.availability,
          loading: false,
          byId,
        },
      }

    case GET_AVAILABILITY_FAILED:
      return {
        ...state,
        availability: {
          ...state.availability,
          error: payload,
        },
      }

    case SET_REVENUE_CENTER_OPTIMISTIC_LIST_IMAGE:
      const { uuid, image } = payload
      return {
        ...state,
        images: {
          ...state.images,
          list: {
            ...state.images.list,
            [uuid]: image,
          },
        },
      }

    default:
      return state
  }
}

export default state
